import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "../../../../../custom.css";
import FilterListIcon from "@mui/icons-material/FilterList";
import ArrowRight from "@mui/icons-material/ArrowForwardIos";
import ArrowDown from "@mui/icons-material/KeyboardArrowDown";
import {
  Container,
  Column,
  CssTextField,
  ButtonDeliveryDate,
  OneColumn,
  SearchButton,
} from "../../../style";
import { Dialog } from "@mui/material";

const FilterDeliveryDate = ({ minDate, maxDate, filterDate }) => {
  const { t } = useTranslation();
  const [activeFilter, setActiveFilter] = useState(false);
  const [fromDate, setFromDate] = useState(minDate);
  const [toDate, setToDate] = useState(maxDate);

  const handleFromDate = (e) => {
    setFromDate(e.target.value);
  };
  const handleToDate = (e) => {
    setToDate(e.target.value);
  };
  const handleOpen = () => {
    setActiveFilter(true);
  };
  const handleClose = () => {
    filterDate(fromDate, toDate);
    setActiveFilter(false);
  };

  return (
    <>
      <Container>
        <ButtonDeliveryDate onClick={handleOpen}>
          <FilterListIcon />
          {t("filter")}
        </ButtonDeliveryDate>
      </Container>
      <Dialog onClose={handleClose} open={activeFilter}>
        <br />
        <Container>
          <Column>
            <CssTextField
              value={fromDate}
              type="date"
              required={true}
              fullWidth
              label={t("fromDate")}
              id="fromDate"
              name="fromDate"
              inputProps={{
                min: minDate,
                max: maxDate,
              }}
              onChange={(e) => handleFromDate(e)}
            />
          </Column>
          <Column>
            <CssTextField
              value={toDate}
              type="date"
              required={true}
              fullWidth
              label={t("toDate")}
              id="toDate"
              name="toDate"
              inputProps={{
                min: minDate,
                max: maxDate,
              }}
              onChange={(e) => handleToDate(e)}
            />
          </Column>
        </Container>
        <Container>
          <OneColumn>
            <SearchButton onClick={handleClose}> {t("filter")}</SearchButton>
          </OneColumn>
        </Container>
      </Dialog>
    </>
  );
};

export default FilterDeliveryDate;
